<template>
  <div />
</template>
<script>
  import createUploader from "@/FormWidgets/uploader/main";

  export default {
    name: "UploaderWrapper",
    props: {
      isOpen: {
        type: Boolean,
        required: true,
      },
      onClose: {
        type: Function,
        required: true,
      },
      attachImage: {
        type: Function,
        required: true,
      },
      tokenUrl: {
        type: String,
        required: true,
      }
    },
    data() {
      return {
        uppy: null,
      };
    },
    watch: {
      isOpen(val) {
        if (val) {
          this.uppy.getPlugin('Dashboard').openModal();
        } else {
          this.uppy.getPlugin('Dashboard').closeModal();
        }
      }
    },
    mounted() {
      // todo: If we refactor this component to use a slot, we can put in the Inbox's InputButton and pass as selector. We could also then make UrlInputWithUpload a wrapper around this component
      // Set up uppy without a selector - we'll trigger it to open programmatically rather than via a DOM click
      this.uppy = createUploader(null, {
        tokenUrl: this.tokenUrl,
        onSuccessfulUpload: this.onSuccessfulUpload
      });
      this.uppy.on('dashboard:modal-closed', () => {
        this.onClose();
      });
    },
    methods: {
      onSuccessfulUpload(name, path) {
        this.attachImage(path, name);
        this.uppy.reset();
      }
    },
  };
</script>
